import controller from './masterpass-card-link-dialog.controller';
import './masterpass-card-link-dialog.less'

export default {
  controller,
  template: require('./masterpass-card-link-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/masterpass-card-link-dialog/masterpass-card-link-dialog.component.ts